import {animate, state, style, transition, trigger} from '@angular/animations';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MyUtils } from 'src/app/services/my-utils.service';


@Component({
  selector: 'app-expand-multi-table',
  templateUrl: './expand-multi-table.component.html',
  styleUrls: ['./expand-multi-table.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ExpandMultiTableComponent implements OnInit, OnChanges {
  @Input() data: any
  @Output() actionReturn = new EventEmitter<any>()

  columnsToDisplay = ['name'];
  columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  expandedElement: any | null | undefined;
  dataList!: any[];
  isEmail: any;
  constructor(
    public utils: MyUtils
  ) { }
  ngOnChanges(changes: SimpleChanges): void {
    this.dataList = []
    this.isEmail = this.data['mail']
    if(!this.isEmail) {
      Object.keys(this.data).forEach(el => {
        this.dataList.push({name: el, obj:this.data[el]})
      })
    } else {
    } 
  }
  

  ngOnInit() {

  
  
    
  }

actionReturnEmit(element: any) {

  let objName = [this.expandedElement.name,...element.objName]
  
  this.actionReturn.emit({action: element.action,objName:objName})
}

  deleteMail(item: any){
    let objName: any = []
    objName.push('mail')
    this.actionReturn.emit({action: {type:'delete',element:item}, objName:objName})
  }

  edit(){
    let objName: any = []
    objName.push('mail')
    this.actionReturn.emit({action: {type:'edit',element:this.data['mail']}, objName:objName})
  }
  create(){
    let objName: any = []
    objName.push('mail')
    this.actionReturn.emit({action: {type:'create',element:this.data['mail']}, objName:objName})
  }

}


